<template>
  <div>
    <ValidationObserver ref="form">
      <div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-tabs alignment="right" v-model="menuCurrentLanguage">
              <vs-tab
                v-if="languages[lang]"
                @click="clickTabChangeLang(lang)"
                :label="languages[lang]"
                v-for="(lang, index) in menuForm.allowedLanguages"
                :key="index"
              >
              </vs-tab>
            </vs-tabs>
          </div>
          <div class="vx-col w-full">
            <h3 class="mb-4">
              <strong>{{ $t("InfoGeneral") }}</strong>
            </h3>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-2 mt-3">
              <ValidationProvider
                name="Nombre"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-input
                  label="Nombre"
                  v-model="menuForm.name"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-2 mt-3">
              <label>{{ $t("Imagen") }}</label>
              <ImageDropzone ref="images" :files="files"></ImageDropzone>
            </vx-input-group>
          </div>
          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <ValidationProvider
                name="Descripción"
                rules="required"
                v-slot="{ errors }"
              >
                <p>{{ $t("Descripcion") }}</p>
                <vs-textarea v-model="menuForm.description" rows="6" />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>

          <div class="vx-col w-full mt-6 div-horario">
            <h3 class="mb-4">
              <strong>{{ $t("Precio") }}</strong>
            </h3>
            <div class="vx-row mt-3 flex">
              <div class="vx-col" style="margin-top: 2.5rem">
                <vs-checkbox v-model="keepPrice">{{
                  $t("SinVariacionPrecio")
                }}</vs-checkbox>
              </div>
              <div class="vx-col">
                <vx-input-group class="mb-2 mt-3">
                  <ValidationProvider
                    name="Precio"
                    rules="required|min_value:0"
                    v-slot="{ errors }"
                  >
                    <vs-input
                      label="Precio"
                      v-model="menuForm.price"
                      type="number"
                      class="w-full"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </ValidationProvider>
                </vx-input-group>
              </div>
            </div>
            <br />
            <div v-if="!keepPrice" class="vx-col w-full hour-container">
              <div class="vx-col mt-10 w-full">{{ $t("EligeHorario") }}</div>
              <div
                class="vx-row flex items-center hour-row-heigth flex"
                style="align-items: flex-start !important"
                v-for="(hour, indexHour) in aux_price_per_hour"
                :key="indexHour"
              >
                <div class="vx-col sm:w-1/12 flex" style="margin-top: 2.25rem">
                  <p style="min-width: 65px">{{ daysTranslate[hour.day] }}</p>
                </div>
                <div class="vx-col sm:w-4/12 hour-range-input">
                  <vx-input-group>
                    <TimeRangeInput
                      :value="{
                        fromTime: aux_price_per_hour[indexHour].since,
                        toTime: aux_price_per_hour[indexHour].until,
                      }"
                      @input="setPricePerHours($event, indexHour)"
                    ></TimeRangeInput>
                  </vx-input-group>
                </div>
                <div class="vx-col sm:w-2/12">
                  <vx-input-group>
                    <ValidationProvider
                      name="Precio"
                      :rules="
                        isPercentage[hour.day]
                          ? 'required|max_value:100'
                          : 'required'
                      "
                      v-slot="{ errors }"
                    >
                      <vs-input
                        :label="isPercentage[hour.day] ? '%Precio' : 'Precio'"
                        min="0"
                        v-model="hour.price"
                        type="number"
                        class="w-full"
                      />
                      <p class="text-danger" style="width: 102.08px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>
                <div class="vx-col md:w-2/12" style="margin-top: 2.25rem">
                  <vs-switch
                    v-model="isPercentage[hour.day]"
                    :disabled="hour.since != ''"
                  >
                    <template #on>
                      {{ $t("percentage") }}
                    </template>
                    <template #off>
                      {{ $t("Price") }}
                    </template>
                  </vs-switch>
                </div>
                <div
                  class="vx-col sm:w-3/12 flex h-10"
                  style="margin-top: 1.75rem"
                >
                  <vs-button size="small" @click="addVariablePrice(indexHour)">
                    {{ $t("ConfirmPrice") }}
                  </vs-button>
                </div>
              </div>

              <div style="max-width: 750px; margin-top: 20px; text-align: left">
                <vs-table :data="menuForm.hours">
                  <template slot="header">
                    <h3>
                      {{ $t("TimePrice") }}
                    </h3>
                  </template>

                  <template slot="thead">
                    <vs-th sort-key="day">
                      {{ $t("Day") }}
                    </vs-th>
                    <vs-th sort-key="hours">
                      {{ $t("Hours") }}
                    </vs-th>
                    <vs-th sort-key="price">
                      {{ $t("Price") }}
                    </vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].day">
                        {{ daysTranslate[data[indextr].day] }}
                      </vs-td>

                      <vs-td :data="data[indextr].hours">
                        <div
                          class="flex items-center"
                          v-for="(
                            hour_with_price, indexHourPrice
                          ) in formatHour(tr.hours)"
                          :key="indexHourPrice"
                        >
                          <p>{{ hour_with_price }}</p>
                        </div>
                      </vs-td>

                      <vs-td :data="data[indextr].price">
                        {{ data[indextr].price }}
                        <span v-if="isPercentage[data[indextr].day]">%</span>
                        <span v-if="!isPercentage[data[indextr].day]">€</span>
                      </vs-td>
                      <vs-td>
                        <vs-button
                          color="danger"
                          type="border"
                          size="small"
                          class="ml-3 w-24"
                          @click="deleteVariablePrice(indextr)"
                        >
                          <feather-icon
                            icon="TrashIcon"
                            svgClasses="w-5 h-5 hover:text-danger stroke-current"
                          />
                        </vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>

          <div class="vx-col w-full mt-6 div-horario">
            <h3 class="mb-4">
              <strong>{{ $t("Horario") }}</strong>
            </h3>
            <div class="row-horario">
              <div class="vx-row justify-center mb-4">
                <div class="vx-col w-40 lg:w-64"></div>
                <div
                  class="vx-col w-32"
                  v-for="(hourDisp, indexHour) in menuForm.disponibility"
                  :key="indexHour"
                >
                  {{ daysTranslate[hourDisp.day] }}
                </div>
              </div>
              <div class="vx-row justify-center mb-4">
                <div class="vx-col w-40 lg:w-64">
                  <p>{{ $t("Desayuno") }}</p>
                </div>
                <div
                  class="vx-col w-32"
                  v-for="(hourDisp, indexHour) in menuForm.disponibility"
                  :key="indexHour"
                >
                  <vs-switch v-model="hourDisp.breakfast" />
                </div>
              </div>
              <div class="vx-row justify-center mb-4">
                <div class="vx-col w-40 lg:w-64">
                  <p>{{ $t("Almuerzo") }}</p>
                </div>
                <div
                  class="vx-col w-32"
                  v-for="(hourDisp, indexHour) in menuForm.disponibility"
                  :key="indexHour"
                >
                  <vs-switch v-model="hourDisp.small_lunch" />
                </div>
              </div>
              <div class="vx-row justify-center mb-4">
                <div class="vx-col w-40 lg:w-64">
                  <p>{{ $t("Brunch") }}</p>
                </div>
                <div
                  class="vx-col w-32"
                  v-for="(hourDisp, indexHour) in menuForm.disponibility"
                  :key="indexHour"
                >
                  <vs-switch v-model="hourDisp.brunch" />
                </div>
              </div>
              <div class="vx-row justify-center mb-4">
                <div class="vx-col w-40 lg:w-64">
                  <p>{{ $t("Comida") }}</p>
                </div>
                <div
                  class="vx-col w-32"
                  v-for="(hourDisp, indexHour) in menuForm.disponibility"
                  :key="indexHour"
                >
                  <vs-switch v-model="hourDisp.lunch" />
                </div>
              </div>
              <div class="vx-row justify-center mb-4">
                <div class="vx-col w-40 lg:w-64">
                  <p>{{ $t("Merienda") }}</p>
                </div>
                <div
                  class="vx-col w-32"
                  v-for="(hourDisp, indexHour) in menuForm.disponibility"
                  :key="indexHour"
                >
                  <vs-switch v-model="hourDisp.snack" />
                </div>
              </div>
              <div class="vx-row justify-center mb-4">
                <div class="vx-col w-40 lg:w-64">
                  <p>{{ $t("Drunch") }}</p>
                </div>
                <div
                  class="vx-col w-32"
                  v-for="(hourDisp, indexHour) in menuForm.disponibility"
                  :key="indexHour"
                >
                  <vs-switch v-model="hourDisp.drunch" />
                </div>
              </div>
              <div class="vx-row justify-center mb-4">
                <div class="vx-col w-40 lg:w-64">
                  <p>{{ $t("Cena") }}</p>
                </div>
                <div
                  class="vx-col w-32"
                  v-for="(hourDisp, indexHour) in menuForm.disponibility"
                  :key="indexHour"
                >
                  <vs-switch v-model="hourDisp.dinner" />
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-6">
              <h3 class="mb-4">
                <strong>{{ $t("product.Inventario") }}</strong>
              </h3>
              <vs-table
                ref="table"
                pagination
                :max-items="itemsPerPage"
                search
                :data="data"
              >
                <div
                  slot="header"
                  class="flex flex-wrap-reverse items-center flex-grow justify-between"
                >
                  <!-- ITEMS PER PAGE -->
                  <vs-dropdown
                    vs-trigger-click
                    class="cursor-pointer mb-4 mr-4"
                  >
                    <div
                      class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                    >
                      <span class="mr-2"
                        >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                        {{
                          data.length - currentPage * itemsPerPage > 0
                            ? currentPage * itemsPerPage
                            : data.length
                        }}
                        of {{ data.length }}</span
                      >
                      <feather-icon
                        icon="ChevronDownIcon"
                        svgClasses="h-4 w-4"
                      />
                    </div>

                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="itemsPerPage = 6">
                        <span>6</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 10">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 15">
                        <span>15</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 20">
                        <span>20</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

                <vs-pagination
                  v-model="currentPage"
                  :max="maxPages < 5 ? 5 : 10"
                  :total="maxPages"
                  @input="normalizeTotalPages(data.length / itemsPerPage)"
                />

                <template slot-scope="{ data }">
                  <draggable
                    :list="data"
                    :group="{ name: 'dishes', pull: 'clone', put: false }"
                    tag="tbody"
                  >
                    <tr :key="index" v-for="(item, index) in data">
                      <td
                        class="td vs-table--td"
                        v-if="dataColumns[indexField].visible && showItem(item)"
                        data="field"
                        :key="keyField"
                        v-for="(field, keyField, indexField) in item"
                      >
                        <div v-if="dataColumns[indexField].dataType == 'slot'">
                          <slot :name="field" :item="item"></slot>
                        </div>
                        <span v-html="field" v-else></span>
                      </td>
                    </tr>
                  </draggable>
                </template>
              </vs-table>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-6">
              <h3 class="mb-4">
                <strong>{{ $t("menu.DetalleMenu") }}</strong>
              </h3>
              <draggable
                :list="menuForm.groups"
                :group="{ name: 'Grupos', pull: false, put: false }"
                class="p-2 cursor-move"
              >
                <vs-list
                  class="mt-5"
                  v-for="(group, indexGroup) in menuForm.groups"
                >
                  <label>{{ $t("menu.NombreGrupo") }}</label>
                  <vx-input-group class="mt-2 mb-4">
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button color="rgb(167, 167, 167)" type="filled">
                          <font-awesome-icon
                            icon="arrows-alt-v"
                            class="w-5 h-5 stroke-current"
                          />
                        </vs-button>
                        <vs-button
                          color="primary"
                          type="border"
                          @click="deleteGroup(indexGroup)"
                        >
                          <feather-icon
                            icon="TrashIcon"
                            svgClasses="w-5 h-5 hover:text-danger stroke-current"
                          />
                        </vs-button>
                      </div>
                    </template>

                    <vs-input
                      v-model="group.name"
                      class="w-full"
                      placeholder="Nombre del grupo"
                    />
                  </vx-input-group>
                  <vx-input-group class="mt-4">
                    <ValidationProvider
                      name="Límite de productos"
                      rules="required|min_value:1"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        v-model="group.dish_limit"
                        class="w-full"
                        type="number"
                        min="1"
                        step="1"
                        label-placeholder="Límite de productos"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                  <br />
                  <h3 class="mb-4">
                    <strong>{{ $t("GrabDish") }}</strong>
                  </h3>
                  <br />
                  <div style="border-width: medium; border-style: solid">
                    <draggable
                      :list="group.dishes"
                      :group="{ name: group.name, put: true }"
                      class="p-2 cursor-move"
                    >
                      <vs-list-item
                        v-for="(dish, indexDish) in group.dishes"
                        :key="indexDish"
                        :title="dish.name"
                        :subtitle="dishDescription(dish.description)"
                      >
                        <vs-input
                          label-placeholder="Suplemento"
                          v-model="dish.supplement"
                          class="mt-8 mb-3 ml-3 w-24"
                        />
                        <vs-button
                          color="danger"
                          type="border"
                          size="small"
                          class="w-24 ml-3"
                          @click="deleteDish(indexGroup, indexDish)"
                        >
                          <feather-icon
                            icon="TrashIcon"
                            svgClasses="w-5 h-5 hover:text-danger stroke-current"
                          />
                        </vs-button>
                      </vs-list-item>
                    </draggable>
                  </div>
                </vs-list>
              </draggable>
              <vs-button @click="addGroup">
                {{ $t("menu.AnyadirGrupo") }}
              </vs-button>
            </div>
          </div>
          <br />
          <div class="vx-col w-full text-right">
            <vs-button
              depressed
              color="success"
              type="border"
              class="mr-2"
              @click.prevent="handleSubmit"
            >
              {{ $t("menu.ActualizarMenu") }}
            </vs-button>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import ImageDropzone from "../ImageDropzone";
import { mapActions, mapGetters, mapMutations } from "vuex";
import TimeRangeInput from "../time-range-input/TimeRangeInput.vue";
export default {
  props: {
    menu: {
      type: Object,
      required: true,
    },
  },
  components: {
    ImageDropzone,
    draggable,
    TimeRangeInput,
  },
  data() {
    return {
      menuForm: {},
      dataColumnsPaged: null,
      currentPageNumber: 1,
      daysTranslate: {
        Monday: "Lunes",
        Tuesday: "Martes",
        Wednesday: "Miércoles",
        Thursday: "Jueves",
        Friday: "Viernes",
        Saturday: "Sábado",
        Sunday: "Domingo",
      },
      isPercentage: {
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
        Sunday: false,
      },
      menuFormOriginal: {},
      files: {},
      dataColumns: [
        { caption: "ID", visible: false },
        { dataField: "move", caption: "", dataType: "text", visible: true },
        { caption: "Imagen", dataType: "image", visible: true },
        {
          dataField: "name",
          caption: "Nombre",
          dataType: "text",
          visible: true,
        },
        {
          dataField: "size",
          caption: "Tamaño",
          dataType: "text",
          visible: true,
        },
        {
          dataField: "price",
          caption: "Precio",
          dataType: "text",
          visible: true,
        },
        { caption: "Descripción", dataType: "text", visible: false },
        { caption: "Suplemento", dataType: "text", visible: false },
      ],
      keepPrice: true,
      itemsPerPage: 15,
      groups: [],
      canChangeLanguage: false,
      menuCurrentLanguage: 0,
      aux_price_per_hour: [
        {
          day: "Monday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Tuesday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Wednesday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Thursday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Friday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Saturday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Sunday",
          since: "",
          until: "",
          price: 0,
        },
      ],
    };
  },
  created() {
    this.menuForm = this.createMenuForm(this.menu);
    this.menuForm.hours.forEach((hour) => {
      switch (hour.day) {
        case "Monday":
          this.aux_price_per_hour[0].since = hour.hours[0];
          break;
        case "Tuesday":
          this.aux_price_per_hour[1].since = hour.hours[0];
          break;
        case "Wednesday":
          this.aux_price_per_hour[2].since = hour.hours[0];
          break;
        case "Thursday":
          this.aux_price_per_hour[3].since = hour.hours[0];
          break;
        case "Friday":
          this.aux_price_per_hour[4].since = hour.hours[0];
          break;
        case "Saturday":
          this.aux_price_per_hour[5].since = hour.hours[0];
          break;
        case "Sunday":
          this.aux_price_per_hour[6].since = hour.hours[0];
          break;
        default:
          break;
      }
    });
    this.menuFormOriginal = JSON.stringify(this.menuForm);
    const files = new Array();
    this.menuForm.images.forEach(function (element) {
      const image = {
        name: element.path,
        url: element.path,
        urlDelete: `/webadmin/daymenus/delete_image/${element.id}`,
      };
      files.push(image);
    });
    this.files = files;
    this.keepPrice = this.menuForm.hours.length <= 0;
    this.refreshDishes({ language: this.language });
  },
  computed: {
    ...mapGetters({
      itemsDishes: "getDishes",
      languages: "getLanguages",
      language: "getCurrentLanguage",
    }),
    currentPage: {
      get() {
        return this.currentPageNumber;
      },
      set(currentPageNumber) {
        this.currentPageNumber = currentPageNumber;
        return this.currentPageNumber;
      },
    },
    data() {
      const items = this.itemsDishes;
      const results = [];
      const placeholder = process.env.VUE_APP_IMAGE_PLACEHOLDER;

      items.forEach(function (item, index) {
        if (items[index].active === 1) {
          const dish = {
            id: items[index].id,
            move: '<div style="width: 50px; height: 50px;" class="flex items-center justify-center" ><i class="fas fa-arrows-alt-h w-5 h-5 stroke-current"></i></div>',
            image: `<img src="${placeholder}" style="width: 75px;" class="product-img" >`,
            name: items[index].name,
            size: items[index].size,
            price: items[index].price,
            description: items[index].description,
            supplement: 0,
          };
          if (items[index].images[0]) {
            dish.image = `<img src="${items[index].images[0].path}" style="width: 75px;" class="product-img" >`;
          }
          results.push(dish);
        }
      }, items);

      return results;
    },
  },
  methods: {
    ...mapActions({
      deleteMenuGroup: "deleteMenuGroup",
      editMenu: "editMenu",
      getMenu: "getMenu",
      refreshDishes: "refreshDishes",
    }),
    ...mapMutations({
      loading: "loading",
    }),
    normalizeTotalPages(totalPages) {
      this.maxPages = Math.ceil(totalPages);
      this.dataColumnsPaged = this.data.slice(
        this.currentPage * this.itemsPerPage - this.itemsPerPage,
        this.currentPage * this.itemsPerPage
      );
    },
    setPricePerHours(event, index) {
      this.aux_price_per_hour[index].since = event.fromTime;
      this.aux_price_per_hour[index].until = event.toTime;
    },
    dishDescription(description) {
      if (description) return description.replace(/<[^>]*>?/gm, " ");
      else return "";
    },

    formatHour(hourToParse) {
      return hourToParse[0]
        .replace("[", "")
        .replace("]", "")
        .replace("/", "-")
        .split(",");
    },

    deleteVariablePrice(indexHour) {
      this.aux_price_per_hour.forEach((hour, index) => {
        if (hour.day == this.menuForm.hours[indexHour].day) {
          hour.since = "";
        }
      });
      this.menuForm.hours.splice(indexHour, 1);
    },

    isEqualGroup(a, b) {
      if (a.length !== b.length) {
        return false;
      } else {
        // comapring each element of array
        for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
        return true;
      }
    },
    handleSubmit(newLang = "", currentLang = "") {
      if (currentLang === "") currentLang = this.menuCurrentLanguage;

      let someGroupEmpty = false;

      this.menuForm.groups.forEach((group) => {
        if (group.dishes.length === 0) {
          someGroupEmpty = true;
        }
      });

      if (someGroupEmpty) {
        this.$store.commit("notifications", {
          title: "Existen errores en el formulario.",
          color: "danger",
          text: "Existe algún grupo vacío.",
        });
        this.$store.commit("showNotifications", true);
        return;
      }

      this.$refs.form.validate().then((success) => {
        if (!success) {
          setTimeout(() => {
            let textAux = "";
            const errors = this.$refs.form.errors;
            if (errors && errors !== undefined) {
              Object.keys(errors).forEach((key) => {
                const error = errors[key];
                if (error.length) {
                  error.forEach(function (text) {
                    textAux += `<p>${text}</p>`;
                  });
                }
              });
            }
            this.$store.commit("notifications", {
              title: "Existen errores en el formulario.",
              color: "danger",
              text: textAux,
            });
            this.$store.commit("showNotifications", true);
          }, 100);
          this.menuCurrentLanguage = currentLang;
          this.canChangeLanguage = true;
          return;
        }

        this.submitted = true;

        const formData = this.createFormData();
        const formGroups = this.createFormGroups(this.menuForm.groups);
        const formGroupsOriginal = this.createFormGroups(
          JSON.parse(this.menuFormOriginal).groups
        );
        const arrayGroups = new Array();

        for (let x = 0; x < formGroups.length; x++) {
          if (
            formGroups[x].id === "NEW" ||
            formGroupsOriginal[x] === undefined
          ) {
            arrayGroups.push(formGroups[x]);
          } else if (
            formGroups[x].id !== formGroupsOriginal[x].id ||
            formGroups[x].dish_limit !== formGroupsOriginal[x].dish_limit ||
            !this.isEqualGroup(
              formGroups[x].dishes,
              formGroupsOriginal[x].dishes
            ) ||
            formGroups[x].name !== formGroupsOriginal[x].name
          ) {
            arrayGroups.push(formGroups[x]);
          }
        }
        this.editMenu({
          id: this.menuForm.id,
          menu: formData,
          groups: arrayGroups,
          language: this.menuForm.currentLanguage,
          newLanguage: newLang,
        });

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
    addGroup() {
      const grupo = {
        id: "NEW",
        name: "Nuevo grupo",
        dishes: [],
      };
      this.menuForm.groups.push(grupo);
    },
    deleteGroup(index) {
      if (this.menuForm.groups[index].id === "NEW") {
        this.menuForm.groups.splice(index, 1);
      } else {
        const aux = this;
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "Eliminar grupo",
          text: `¿Deseas eliminar el grupo '${aux.menuForm.groups[index].name}'?`,
          acceptText: "Aceptar",
          cancelText: "Cancelar",
          accept() {
            aux.deleteMenuGroup(aux.menuForm.groups[index].id);
            aux.menuForm.groups.splice(index, 1);
          },
        });
      }
    },
    deleteDish(indexGroup, indexDish) {
      this.menuForm.groups[indexGroup].dishes.splice(indexDish, 1);
    },
    createMenuForm(menu) {
      const groupsArray = new Array();
      for (let i = 0; i < menu.group.length; i++) {
        const auxGroup = {
          id: menu.group[i].id,
          name: menu.group[i].name,
          dish_limit: menu.group[i].dish_limit,
          dishes: [],
        };
        const placeholder = process.env.VUE_APP_IMAGE_PLACEHOLDER;
        for (let x = 0; x < menu.group[i].dishes.length; x++) {
          const auxDish = {
            id: menu.group[i].dishes[x].dish.id,
            image: `<img src="${placeholder}" style="width: 75px;" class="product-img" >`,
            name: menu.group[i].dishes[x].dish.name,
            size: menu.group[i].dishes[x].dish.size,
            price: menu.group[i].dishes[x].dish.price,
            description: menu.group[i].dishes[x].dish.description,
            supplement: menu.group[i].dishes[x].supplement,
          };
          if (menu.group[i].dishes[x].dish.images[0]) {
            auxDish.image = `<img src="${menu.group[i].dishes[x].dish.images[0].path}" style="width: 75px;" class="product-img" >`;
          }
          auxGroup.dishes.push(auxDish);
        }

        groupsArray.push(auxGroup);
      }
      const arrayAllowedLanguages = eval(menu.allowed_languages);
      if (arrayAllowedLanguages && arrayAllowedLanguages !== undefined) {
        for (let i = 0; arrayAllowedLanguages.length > i; i++) {
          if (arrayAllowedLanguages[i] === menu.current_language) {
            this.menuCurrentLanguage = i;
            this.canChangeLanguage = true;
          }
        }
      }

      if (menu.disponibility.length === 0) {
        menu.disponibility = [
          {
            day: "Monday",
            breakfast: 0,
            lunch: 0,
            dinner: 0,
            drunch: 0,
            brunch: 0,
            snack: 0,
            small_lunch: 0,
          },
          {
            day: "Tuesday",
            breakfast: 0,
            lunch: 0,
            dinner: 0,
            drunch: 0,
            brunch: 0,
            snack: 0,
            small_lunch: 0,
          },
          {
            day: "Wednesday",
            breakfast: 0,
            lunch: 0,
            dinner: 0,
            drunch: 0,
            brunch: 0,
            snack: 0,
            small_lunch: 0,
          },
          {
            day: "Thursday",
            breakfast: 0,
            lunch: 0,
            dinner: 0,
            drunch: 0,
            brunch: 0,
            snack: 0,
            small_lunch: 0,
          },
          {
            day: "Friday",
            breakfast: 0,
            lunch: 0,
            dinner: 0,
            drunch: 0,
            brunch: 0,
            snack: 0,
            small_lunch: 0,
          },
          {
            day: "Saturday",
            breakfast: 0,
            lunch: 0,
            dinner: 0,
            drunch: 0,
            brunch: 0,
            snack: 0,
            small_lunch: 0,
          },
          {
            day: "Sunday",
            breakfast: 0,
            lunch: 0,
            dinner: 0,
            drunch: 0,
            brunch: 0,
            snack: 0,
            small_lunch: 0,
          },
        ];
      }

      return {
        name: menu.name,
        price: menu.price,
        description: menu.description,
        id: menu.id,
        images: menu.images,
        hours: menu.hours,
        disponibility: menu.disponibility,
        groups: groupsArray,
        allowedLanguages: arrayAllowedLanguages,
        currentLanguage: menu.current_language,
      };
    },
    createFormData() {
      const data = this.$refs.images.getFormData();
      data.append("name", this.menuForm.name);
      data.append("price", this.menuForm.price);
      data.append("description", this.menuForm.description);

      for (let i = 0; i < this.menuForm.hours.length; i++) {
        const day = this.menuForm.hours[i].day;
        if (this.isPercentage[day]) {
          this.menuForm.hours[i].percentage = this.menuForm.hours[i].price;
          this.menuForm.hours[i].price = null;
        } else {
          this.menuForm.hours[i].percentage = null;
        }

        if (!Array.isArray(this.menuForm.hours[i].hours)) {
          this.menuForm.hours[i].hours = [this.menuForm.hours[i].hours];
        }

        data.append(`hours[${i}]`, JSON.stringify(this.menuForm.hours[i]));
      }

      for (let i = 0; i < this.menuForm.disponibility.length; i++) {
        data.append(
          `disponibility[${i}]`,
          JSON.stringify(this.menuForm.disponibility[i])
        );
      }
      return data;
    },

    createFormGroups(groups) {
      // const data = new FormData();
      const data = new Array();

      for (let i = 0; i < groups.length; i++) {
        const arrayDishes = new Array();
        for (let x = 0; x < groups[i].dishes.length; x++) {
          const dish = {
            id: groups[i].dishes[x].id,
          };
          if (
            groups[i].dishes[x].supplement === undefined ||
            groups[i].dishes[x].supplement === ""
          ) {
            dish.supplement = 0;
          } else {
            dish.supplement = groups[i].dishes[x].supplement;
          }
          arrayDishes.push(JSON.stringify(dish));
        }
        const group = {
          id: groups[i].id,
          name: groups[i].name,
          order: i,
          dish_limit: groups[i].dish_limit,
          dishes: arrayDishes,
        };
        data.push(group);
      }

      return data;
    },
    clickTabChangeLang(value) {
      const arrayAllowedLanguages = this.menuForm.allowedLanguages;
      if (this.menuForm.currentLanguage !== value) {
        const currentLanguage = this.menuForm.currentLanguage;
        let indexCurrentLanguage = 0;
        for (let i = 0; arrayAllowedLanguages.length > i; i++) {
          if (arrayAllowedLanguages[i] === currentLanguage) {
            indexCurrentLanguage = i;
          }
        }
        this.changeLanguage(value, indexCurrentLanguage);
      }
    },
    addVariablePrice(index) {
      this.aux_price_per_hour[index].since = this.aux_price_per_hour[index]
        .since
        ? this.aux_price_per_hour[index].since
        : "00:00";
      this.aux_price_per_hour[index].until = this.aux_price_per_hour[index]
        .until
        ? this.aux_price_per_hour[index].until
        : "23:59";

      let varPrice = {
        day: this.aux_price_per_hour[index].day,
        price: this.aux_price_per_hour[index].price,
        hours: [
          `${this.aux_price_per_hour[index].since}/${this.aux_price_per_hour[index].until}`,
        ],
        percentage: false,
      };

      switch (varPrice.day) {
        case "Monday":
          varPrice.percentage = this.isPercentage.Monday;
          break;
        case "Tuesday":
          varPrice.percentage = this.isPercentage.Tuesday;
          break;
        case "Wednesday":
          varPrice.percentage = this.isPercentage.Wednesday;
          break;
        case "Thursday":
          varPrice.percentage = this.isPercentage.Thursday;
          break;
        case "Friday":
          varPrice.percentage = this.isPercentage.Friday;
          break;
        case "Saturday":
          varPrice.percentage = this.isPercentage.Saturday;
          break;
        case "Sunday":
          varPrice.percentage = this.isPercentage.Sunday;
          break;
        default:
          break;
      }

      //Si el precio es porcentaje
      if (
        (varPrice.percentage && !/^[1-9][0-9]?$|^100$/.test(varPrice.price)) ||
        !/^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/.test(
          varPrice.price
        )
      ) {
        this.$store.commit("notifications", {
          title: "menu.InvalidPrice",
          color: "warning",
        });
        this.$store.commit("showNotifications", true);
        return;
      }

      for (let i = 0; i < this.menuForm.hours.length; i++) {
        //Si ya hay un horario en ese día con ese precio
        if (
          this.menuForm.hours[i].day === varPrice.day &&
          this.menuForm.hours[i].price === varPrice.price
        ) {
          //Si es el mismo horario, avisar de que está repetido
          if (this.menuForm.hours[i].hours.includes(varPrice.hours[0])) {
            this.$store.commit("notifications", {
              title: "menu.AlreadyExists",
              color: "warning",
            });
            this.$store.commit("showNotifications", true);
            return;
          }
          //Si no es el mismo horario, añadir a la lista de horarios de ese precio en ese día
          this.$store.commit("notifications", {
            title: "menu.UpdateVariableMenuPrice",
          });
          this.$store.commit("showNotifications", true);
          this.menuForm.hours[i].hours.push(varPrice.hours[0]);
          return;
        } else if (
          this.menuForm.hours[i].day === varPrice.day &&
          this.menuForm.hours[i].hours.includes(varPrice.hours[0])
        ) {
          //Si el horario es el mismo en el mismmo día pero con precios distintos, no puede tener dos precios distintos a la vez
          this.$store.commit("notifications", {
            title: "menu.DifferentPrice",
            color: "warning",
          });
          this.$store.commit("showNotifications", true);
          return;
        }
      }

      this.menuForm.hours.push(varPrice);
      this.$store.commit("notifications", { title: "menu.HorarioAnyadido" });
      this.$store.commit("showNotifications", true);
    },
    changeLanguage(lang, currentIndex) {
      const aux = this;
      aux.canChangeLanguage = false;
      if (JSON.stringify(aux.menuForm) !== aux.menuFormOriginal) {
        this.$vs.dialog({
          type: "confirm",
          color: "success",
          title: this.$t("changeLanguage"),
          text: this.$t("textChangeLanguage"),
          acceptText: aux.$t("SalirGuardar"),
          cancelText: aux.$t("Cancelar"),
          accept() {
            aux.handleSubmit(lang, currentIndex);
          },
          cancel() {
            aux.menuCurrentLanguage = currentIndex;
            aux.canChangeLanguage = true;
          },
        });
      } else {
        aux.loading(true);
        aux.getMenu({ id: aux.menuForm.id, language: lang });
        aux.loading(false);
      }
    },
    showItem(item) {
      let show = true;
      this.menuForm.groups.forEach((group) =>
        group.dishes.find((element) => {
          if (element.name === item.name) {
            show = false;
          }
        })
      );

      return show;
    },
  },
};
</script>
<style>
.hour-row-heigth {
  align-items: center !important;
}
.hour-range-input {
  display: flex !important;
  align-items: center;
  margin-bottom: 1.25rem;
  justify-content: center;
}
</style>
